module.exports = __webpack_public_path__ + "static/media/qiao.f6c6dabe.jpg";